import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layouts/MainLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        path: 'orders',
        name: 'OrderList',
        component: () => import('@/views/orders/List.vue'),
        meta: { title: '客户订单管理', icon: 'el-icon-s-order' }
      },
      {
        path: 'orders/create',
        name: 'OrderCreate',
        component: () => import('@/views/orders/Create.vue'),
        meta: { title: '创建客户订单', icon: 'el-icon-plus' }
      },
      {
        path: 'orders/edit/:orderNo',
        name: 'OrderEdit',
        component: () => import('@/views/orders/Create.vue'),
        meta: { title: '编辑草稿订单', icon: 'el-icon-edit' }
      },
      {
        path: 'orders/batch',
        name: 'OrderBatchCreate',
        component: () => import('@/views/orders/BatchCreate.vue'),
        meta: { title: '批量下单', icon: 'el-icon-s-operation' }
      },
      {
        path: 'tracking',
        name: 'Tracking',
        component: () => import('@/views/orders/Tracking.vue'),
        meta: { title: '轨迹查询', icon: 'el-icon-map-location' }
      },
      {
        path: 'fees',
        name: 'FeeQuery',
        component: () => import('@/views/orders/FeeQuery.vue'),
        meta: { title: '费用查询', icon: 'el-icon-money' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: { title: '个人信息', icon: 'el-icon-user' }
      },
      {
        path: 'keys',
        name: 'ApiKeys',
        component: () => import('@/views/ApiKeys.vue'),
        meta: { title: '密钥和Key', icon: 'el-icon-key' }
      },
      {
        path: 'system/roles',
        name: 'RoleMgmt',
        component: () => import('@/views/system/Role.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-check' }
      },
      {
        path: 'system/users',
        name: 'UserMgmt',
        component: () => import('@/views/system/User.vue'),
        meta: { title: '用户管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'system/bindings',
        name: 'PlatformBinding',
        component: () => import('@/views/system/Binding.vue'),
        meta: { title: '平台绑定', icon: 'el-icon-connection' }
      },
      {
        path: 'api-docs',
        name: 'ApiDocs',
        component: () => import('@/views/ApiDocs.vue'),
        meta: { title: 'API文档', icon: 'el-icon-document' }
      },
      {
        path: 'credit-audit',
        name: 'CreditAudit',
        component: () => import('@/views/CreditAudit.vue'),
        meta: { title: '余额与额度', icon: 'el-icon-money' }
      },
      {
        path: 'pricing/zones',
        name: 'SubZone',
        component: () => import('@/views/pricing/SubZone.vue'),
        meta: { title: '子分区设置', icon: 'el-icon-map-location' }
      },
      {
        path: 'pricing/weights',
        name: 'SubWeight',
        component: () => import('@/views/pricing/SubWeight.vue'),
        meta: { title: '子重量段设置', icon: 'el-icon-s-marketing' }
      },
      {
        path: 'pricing/fee-types',
        name: 'SubFeeType',
        component: () => import('@/views/pricing/SubFeeType.vue'),
        meta: { title: '子费用类型', icon: 'el-icon-tickets' }
      },
      {
        path: 'pricing/freights',
        name: 'SubFreight',
        component: () => import('@/views/pricing/SubFreight.vue'),
        meta: { title: '子运费设置', icon: 'el-icon-money' }
      },
      {
        path: 'sub-account-receivable',
        name: 'SubAccountReceivable',
        component: () => import('@/views/finance/SubAccountReceivable.vue'),
        meta: { title: '子账户应收', icon: 'el-icon-money' }
      },
      {
        path: 'sub-account-fees',
        name: 'SubFeeQuery',
        component: () => import('@/views/finance/SubFeeQuery.vue'),
        meta: { title: '子费用查询', icon: 'el-icon-money' }
      },
      {
        path: 'sub-account-audits',
        name: 'SubAudit',
        component: () => import('@/views/finance/SubAudit.vue'),
        meta: { title: '子审核记录', icon: 'el-icon-money' }
      },
      {
        path: 'balance-records',
        name: 'BalanceRecord',
        component: () => import('@/views/finance/BalanceRecord.vue'),
        meta: { title: '余额明细', icon: 'el-icon-money' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 清理历史遗留的 hash 路由（旧版 hash 模式留下的 #/xxx），重定向到干净的路径
  const hash = window.location.hash
  if (hash && hash.startsWith('#/')) {
    window.location.replace(hash.slice(1))
    return
  }
  const token = sessionStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
    return
  }
  // TTWL 客户隐藏费用查询
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || 'null')
  if (to.path === '/fees' && userInfo && userInfo.customerCode === 'TTWL') {
    next('/home')
    return
  }
  next()
})

// Chunk 加载失败自动刷新
router.onError(error => {
  const chunkFailedPattern = /Loading (CSS )?chunk [\w-]+ failed/i
  if (chunkFailedPattern.test(error.message)) {
    console.warn('Chunk 加载失败，自动刷新页面...', error.message)
    window.location.reload()
  }
})

export default router
